import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, FormControlLabel, TextField, Typography } from '@mui/material';
import { toast } from "react-toastify";
import { SettingsOptionsDataTable } from '../SettingsScreen';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SearchableDropdown from '../../../../components/SearchableDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { getSettingAgencies, getVendorSettingConstantsAction2 } from '../../../../store/Settings/action';
import { convertToOptionList } from '../../../../constants/config';

const VendorSettingUModal = ({ open = false, mode = 'add', vendorId = "", handleClose, handleAdd, handleUpdate, handleMerge, currentData = null, activePill = null }) => {
	const dispatch = useDispatch();
	const settingsData = useSelector((state) => state.settingsConstants);
	const list2 = useSelector((state) => state.settingsConstants.list2);
	const maxPage = useSelector((state) => state.settingsConstants.maxPage2);
	const currentPage = useSelector((state) => state.settingsConstants.currentPage2);
	const [step, setStep] = useState(0);
	const [merge, setMerge] = useState(false);
	const [list, setList] = useState([]);
	const [data, setData] = useState(null);
	const [agencies, setAgencies] = useState([]);
	const [searchText, setSearchText] = useState('');

	useEffect(() => {
		let d = {};
		if (mode == 'add') {
			(activePill?.variables || []).map((a) => {
				if (currentData?.[a.key]) {
					d[a.key] = "";
				}
			});
		} else {
			(activePill?.editVariables || activePill?.variables || []).map((a) => {
				if (currentData?.[a.key]) {
					d[a.key] = currentData[a.key];
				}
			});
		}
		dispatch(getVendorSettingConstantsAction2({ id: vendorId, type: activePill.apiFieldName, searchText: '', page: 0 }));
		setData(d);
	}, [currentData]);

	const handlePageChange = (pageNo) => {
		dispatch(getVendorSettingConstantsAction2({ id: vendorId, type: activePill.apiFieldName, searchText: searchText, page: pageNo }));
	};

	const handleSearch = (value = "") => {
		setSearchText(value);
		dispatch(getVendorSettingConstantsAction2({ id: vendorId, type: activePill.apiFieldName, searchText: '', page: 0 }));
	};

	const handleDropdownSearch = (e) => {
		if (e.target.value) {
			dispatch(getSettingAgencies({ type: activePill.apiFieldName, searchText: e.target.value }, (res) => {
				var newOptions = convertToOptionList(res?.data?.data || [], 'options');
				setAgencies(newOptions);
			}));
		}
	}

	const handleModalClose = () => {
		setData(null);
		setStep(0);
		setMerge(false);
		setList([]);
		setAgencies([]);
		handleClose();
	}

	const handleNext = () => {
		const check = checkValid();
		if (check) {
			setStep(prev => prev + 1);
		} else {
			toast.error("Please fill all required fields", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000,
			});
		}
	}

	const handleBack = () => {
		setStep(prev => prev - 1);
	}

	const handleMergeOption = () => {
		handleMerge({ data: data, id: currentData?.id, replace: list });
		setData(null);
		setStep(0);
		setMerge(false);
		setList([]);
		setAgencies([]);
	}

	const handleAddOption = () => {
		const check = checkValid();
		if (check) {
			handleAdd({ ...data });
			setData(null);
			setStep(0);
			setMerge(false);
			setList([]);
			setAgencies([]);
		} else {
			toast.error("Please fill all required fields", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000,
			});
		}
	}

	const handleUpdateOption = () => {
		const check = checkValid();
		if (check) {
			handleUpdate({ ...data, id: currentData?.id });
			setData(null);
			setStep(0);
			setMerge(false);
			setList([]);
			setAgencies([]);
		} else {
			toast.error("Please fill all required fields", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000,
			});
		}
	}

	const handleChange = (name, value) => {
		setData(prev => {
			return {
				...prev,
				[name]: value
			}
		});
	}

	const checkValid = () => {
		let v = [], valid = true;
		if (mode == 'add') {
			(activePill?.variables || []).map((a) => {
				v.push(a.key);
			});
		} else {
			(activePill?.editVariables || activePill?.variables || []).map((a) => {
				v.push(a.key);
			});
		}
		v.map((item) => {
			if (!data[item]) {
				valid = false;
			}
		})
		return valid;
	}

	const textInputs = mode === 'add' ? activePill?.variables || [] : activePill?.editVariables || activePill?.variables || [];

	return (
		<Dialog
			open={open}
			onClose={handleModalClose}
			aria-labelledby="add-item-modal"
			aria-describedby="add-item-modal-description"
			fullWidth
			maxWidth={step === 1 ? "md" : "sm"}
		>
			<DialogContent>
				<Typography variant='h6'>{step == 1 ? "" : currentData?.id ? "Update" : ("Add" + " option")}</Typography>
				{step === 0 ?
					<Box>
						{textInputs.map((item, index) => {
							if (item?.type === 'date') {
								return (
									<Box mt={1} key={index}>
										<Typography variant='subtitle2'>Enter {item?.label || ""} <Typography display="inline" sx={{ color: 'red' }}>*</Typography></Typography>
										<LocalizationProvider dateAdapter={AdapterDayjs}>
											<DatePicker
												renderInput={(inputProps) =>
													<TextField
														InputLabelProps={{ shrink: true }}
														type="date"
														value={data?.[item.key] || ""}
														variant="outlined"
														onChange={(e) => {
															handleChange(item.key, e.target.value);
														}}
													/>}
											/>
										</LocalizationProvider>
									</Box>
								)
							} else if (item?.type === 'searchable-drodown') {
								return (
									<Box mt={1} key={index}>
										<Typography variant='subtitle2'>Select an {item.label} <Typography display="inline" sx={{ color: 'red' }}>*</Typography></Typography>
										<SearchableDropdown loading={settingsData?.agencyLoading} options={agencies} label={'Search ' + item.label} handleInputChange={handleDropdownSearch} handleChange={(e, v, r) => { handleChange(item.key, v.id) }} />
									</Box>
								)
							}
							return (
								<Box mt={1} key={index}>
									<Typography variant='subtitle2'>Enter {item?.label || ""} <Typography display="inline" sx={{ color: 'red' }}>*</Typography></Typography>
									<TextField
										value={data?.[item.key] || ""}
										onChange={(e) => handleChange(item.key, e.target.value)}
										placeholder={"Please add a " + item.label + "!"}
										sx={{ width: "100%", background: "#FFFFFF", mt: 1 }}
										inputProps={{ paddingBottom: "100px" }}
									/>
								</Box>
							)
						})}
						<FormControlLabel control={<Checkbox checked={merge} onChange={() => setMerge(prev => !prev)} />} label="Merge with other options" />
					</Box>
					:
					<Box>
						<SettingsOptionsDataTable
							title={"Select the options you want to merge with:"}
							data={list2}
							columns={activePill.columns}
							maxPage={maxPage}
							currentPage={currentPage}
							selectionMode={true}
							searchText={searchText}
							handleSelection={setList}
							handlePageChange={handlePageChange}
							requestSearch={handleSearch}
							selectedTabledData={list}
							disabledRows={currentData?.id ? [currentData.id] : []}
						/>
					</Box>
				}
			</DialogContent>
			<DialogActions>
				{step === 1 ?
					<Button id='back-btn' onClick={handleBack}>Go Back</Button>
					:
					<Button id='close-btn' onClick={handleModalClose}>Close</Button>
				}
				{merge
					?
					step === 0
						?
						<Button id='next-btn' onClick={handleNext} variant='contained'>Next</Button>
						:
						<Button id='merge-btn' onClick={handleMergeOption} variant='contained'>{currentData?.id ? "Update" : "Add"} & Merge</Button>
					:
					<Button id='submit-btn' onClick={() => currentData?.id ? handleUpdateOption() : handleAddOption()} variant='contained'>{currentData?.id ? "Update" : "Add"}</Button>
				}
			</DialogActions>
		</Dialog>
	)
}

export default VendorSettingUModal;